import { clientService } from "../../../api/axios-client-api"

const paratiApi = clientService.paratiApi

export const GetParatiJSON = async (): Promise<any> => {
  return paratiApi.Get("/parati.json").then(res => res.data);
}